import { IUpdateUserPermissionsActionPayload } from '../interfaces/update-user-permissions-payload.interface';

export class RemoveUserPermissions {
    static readonly type = '[User] RemoveUserPermissions';

    constructor(public payload: IUpdateUserPermissionsActionPayload) {}
}
